import React from "react";

export default function SidebarImg() {
  return (
    <svg
      width="40px"
      height="40px"
      viewBox="0 0 39 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_111_3831)">
        <circle
          cx="19.5"
          cy="15.4902"
          r="15.5"
          fill="url(#paint0_linear_111_3831)"
          shapeRendering="crispEdges"
        />
      </g>
      <path
        d="M13.6445 11.7014H24.6668"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6445 15.8347H24.6668"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6445 19.968H24.6668"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_d_111_3831"
          x="0"
          y="-0.00976562"
          width="39"
          height="39"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_111_3831"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_111_3831"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_111_3831"
          x1="19.1556"
          y1="40.6347"
          x2="59.4556"
          y2="-11.7209"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1D56C6" />
          <stop offset="0.9" stopColor="#4E46E6" stopOpacity="0.1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
